/* eslint-disable no-unused-vars */
import store from 'store';
import * as req from 'api/actions';
import _ from 'lodash';
import alert from 'react-s-alert';
import * as c from './constants';

export const login = (payload, callback) =>
  req.loginCreate(c.LOGIN, '/api/v1/authenticate', payload, ({ res }) => {
    const otpReceiver =
      _.get(res, 'data.otp_receiver') || _.get(res, 'res.data.otp_receiver');
    const authToken =
      _.get(res, 'res.auth_token') || _.get(res, 'auth_token');
    localStorage.setItem('email', payload.email);
    localStorage.setItem('otpReceiver', otpReceiver || payload.email);
    if (authToken) localStorage.setItem('auth_token', authToken);
    callback();
  });

export const verifyOtp = (payload, callback) =>
  req.create(c.VERIFY_OTP, '/api/v1/verify_otp', payload, ({ res }) => {
    const enableProfile = res.data;
    const { data, token, permissions, roles } = res.res;
    const profile = _.get(data, 'attributes');
    const id = _.get(data, 'id');
    localStorage.setItem('token', token);
    sessionStorage.setItem('sc_post_login_modal', '1');
    localStorage.setItem('profile', JSON.stringify({ ...profile, id }));
    localStorage.setItem('enableProfile', JSON.stringify(enableProfile));
    localStorage.setItem(
      'permissions',
      JSON.stringify(_.map(permissions, 'name'))
    );
    localStorage.setItem('roles', JSON.stringify(roles));
    store.dispatch(req.setItem(c.AUTH, { token, isAuthenticated: true }));
    store.dispatch(req.setItem(c.USER_PROFILE, profile));
    if (callback) callback(profile);
  });

export const resendOtp = (payload, callback) =>
  req.create(
    c.RESEND_OTP,
    '/api/v1/resend_otp',
    payload,
    ({ res }) => {
      const message =
        _.get(res, 'res.data.message') || _.get(res, 'data.message');
      const authToken =
        _.get(res, 'res.auth_token') || _.get(res, 'auth_token');
      if (authToken) localStorage.setItem('auth_token', authToken);
      if (message) alert.success(message);
      if (callback) callback(res);
    },
    { defaultMessage: false }
  );

export const verifyOtpSource = (payload, callback) =>
  req.create(
    c.VERIFY_OTP_SOURCE,
    '/api/v1/administrators/verify_otp_source',
    payload,
    () => {
      if (callback) callback();
    }
  );

export const mfaLogin = (payload, callback) =>
  req.create(
    c.MFA_LOGIN,
    '/api/v1/mfa_authenticate',
    payload,
    ({ res }) => {
      const { data, token, permissions } = res.res;
      const profile = _.get(data, 'attributes');
      localStorage.setItem('token', token);
      sessionStorage.setItem('sc_post_login_modal', '1');
      localStorage.setItem('profile', JSON.stringify(profile));
      localStorage.setItem(
        'permissions',
        JSON.stringify(_.map(permissions, 'name'))
      );

      store.dispatch(req.setItem(c.AUTH, { token, isAuthenticated: true }));
      store.dispatch(req.setItem(c.USER_PROFILE, profile));
      if (callback) callback(profile);
    },
    {
      defaultMessage: 'You have successfully logged in!',
    }
  );

// export const logout = callback =>
//   req.setItemDelay(c.LOGOUT, {}, () => {
//     localStorage.clear();
//     localStorage.clear();
//     store.dispatch(
//       req.setItem(c.AUTH, { token: null, isAuthenticated: false })
//     );
//     if (callback) callback();
//   });

export const logout = (payload, callback) =>
  req.update(
    c.LOGOUT,
    '/api/v1/administrators/logout',
    payload,
    callback,
    (res) => {
      localStorage.clear();
      localStorage.clear();
      sessionStorage.removeItem('sc_post_login_modal');
      store.dispatch(
        req.setItem(c.AUTH, { token: null, isAuthenticated: false })
      );
      callback();
    }
  );

export const forgotPass = (params, callback) =>
  req.create(
    c.FORGOT_PASS,
    '/api/v1/administrators/forgot_password',
    params,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Please check your Email!');
      if (callback) callback();
    }
  );

export const verifyMobile = (params, callback) =>
  req.create(
    c.VERIFY_MOBILE,
    '/api/v1/administrators/forgot_password_change',
    params,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'You Successfully change your password!');
      if (callback) callback();
    }
  );

export const getDemoList = (payload, callback) =>
  req.list(c.GET_DEMO_LIST, '/api/v1/layout_settings/', payload, callback);

export const getDemo = (id, payload, callback) =>
  req.item(c.GET_DEMO_INFO, `/api/v1/layout_settings/${id}`, payload, callback);

export const createDemo = (params, callback) =>
  req.create(c.CREATE_DEMO, '/api/v1/layout_settings', params, (res) => {
    const { message } = res.res;
    alert.success(message || 'You added city for demo!');
    if (callback) callback();
  });

export const updateDemo = (id, payload, callback) =>
  req.update(c.UPDATE_DEMO, `/api/v1/layout_settings/${id}`, payload, callback);

export const verifyLogin = (id, payload, callback) =>
  req.update(c.VERIFY_LOGIN, `/api/v1/verify_login/${id}`, payload, callback);

export const resetPassword = (params, callback) =>
  req.create(
    c.RESET_PASSWORD,
    '/api/v1/administrators/reset-password',
    params,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'You Successfully reset your password!');
      if (callback) callback();
    }
  );

export const getFeedbackSettings = (payload, callback) =>
  req.item(
    c.GET_FEEDBACK_SETTINGS,
    `/api/v1/administrators/feedback_forms/settings`,
    payload,
    callback
  );

export const getLgu = (payload = {}, callback = () => {}) =>
  req.item(c.GET_LGU, '/api/pub/common/lgu', callback, payload);
  